<script setup lang="ts">
  import type {
    AiPromptAsset,
    TargetPromptAiModel,
    PromptTargetType
  } from '../model/types'
  import { Modal, ModalHeaderTitle, Button } from '@gat-ship/vue-components'
  import SmartPasteForm from './SmartPasteForm.vue'
  import { IconMagicWand, IconLoading } from '@gat-ship/icons'

  defineProps<{
    promptType: PromptTargetType
    assets: AiPromptAsset[]
    canManageAssets: boolean
    canOverrideModel: boolean
    isExtracting: boolean
  }>()

  const isOpen = defineModel<boolean>('open', { required: true })

  const text = defineModel<string>('text', { required: true })

  const selectedAssetId = defineModel<string | undefined>('selectedAssetId', {
    required: true
  })

  const selectedThinkingModel = defineModel<TargetPromptAiModel | undefined>(
    'selectedThinkingModel',
    { required: true }
  )

  const emit = defineEmits<{
    (e: 'submit'): void
    (e: 'add-asset'): void
    (e: 'edit-asset', asset: AiPromptAsset): void
  }>()

  function onFillFormClicked() {
    emit('submit')
  }
</script>

<template>
  <modal v-model:open="isOpen" type="dialog" class="w-full max-w-6xl">
    <ModalHeaderTitle class="px-5 pt-5">
      {{ promptType === 'data-extraction' ? 'Extract Data' : 'Summarize Text' }}
    </ModalHeaderTitle>
    <SmartPasteForm
      v-model:text="text"
      v-model:selected-asset-id="selectedAssetId"
      v-model:selected-thinking-model="selectedThinkingModel"
      :loading="isExtracting"
      :assets="assets"
      :can-manage-assets="canManageAssets"
      :can-override-model="canOverrideModel"
      @add-asset="emit('add-asset')"
      @edit-asset="emit('edit-asset', $event)"
    >
      <template #actions>
        <Button
          class="ml-auto"
          variant="ghost"
          size="lg"
          @click="isOpen = false"
        >
          Cancel
        </Button>
        <Button :disabled="isExtracting" size="lg" @click="onFillFormClicked">
          <IconLoading v-if="isExtracting" class="size-4 shrink-0" />
          <IconMagicWand v-else class="size-4" />
          Fill Form
        </Button>
      </template>
    </SmartPasteForm>
  </modal>
</template>
